"use strict";
const createSearchStringQuery = () => ({});
module.exports = createSearchStringQuery;
